import React from 'react'
import { Route, Routes } from 'react-router-dom';
import ChangePin from '../Credentials/changePin';
import Profile from '../Profile/profile';

import State from '../State/state';
import AddState from '../State/addState';
import EditState from '../State/editState';

import Country from '../Country/country';
import AddCountry from '../Country/addCountry';
import EditCountry from '../Country/editCountry';

import PromotionalAddOn from '../promotionalAddOn/promotionalAddOn';
import AddPromotionalAddOn from '../promotionalAddOn/addPromotionalAddOn';
import EditPromotionalAddOn from '../promotionalAddOn/editPromotionalAddOn';

import Provider from '../Provider/provider';
import AddProvider from '../Provider/addProvider';
import EditProvider from '../Provider/editProvider';
import AssignPlan from '../Provider/assignPlan';
import PlanHistory from '../Provider/viewDetails';
import PaymentHistory from '../Provider/viewPlanPaymentHistory';


import Dashboard from '../Dashboard/dashboard';

import Appointment from '../Appointment/appointment';
import AppointmentView from '../Appointment/appointmentView';

import Revenue from '../Revenue/revenue';

import Notifications from '../Notifications/notifications';
import NoFoundPage from '../Credentials/noFoundPage';

import TimeZone from '../Time Zone/timeZone';

import LeadManagement from '../Subscription/Lead Management/leadList';
import View from '../Subscription/Lead Management/view';
import AddLead from '../Subscription/Lead Management/addLead';
import EditLead from '../Subscription/Lead Management/editLead';
import TeamList from '../Subscription/Team/teamList';
import AddTeam from '../Subscription/Team/addTeam';
import CancellationPolicy from '../Subscription/Cancellation Policy/list';
import AddPolicy from '../Subscription/Cancellation Policy/addPolicy';
import EditPolicy from '../Subscription/Cancellation Policy/editPolicy';
import LeadHistory from '../Subscription/Lead Management/leadHistory';

import RoleList from '../Role/roleList';
import AddRole from '../Role/addRole';
import ServiceDuration from '../Service Duration/serviceDuration';
import AddDuration from '../Service Duration/addDuration';

// Contact
import Contact from '../Campaign/Contact/contact';
import AddContact from '../Campaign/Contact/addContact';

// Group
import Group from '../Campaign/Group/group';
import MainPage from '../Campaign/mainPage';
import AddGroup from '../Campaign/Group/addGroup';

// Campaign
import Campaign from '../Campaign/Campaign/campaign';
import AddCampaign from '../Campaign/Campaign/addCampaign';
import EmailCampaign from '../Campaign/Campaign/emailCampaign';
import WebhookList from '../Campaign/Webhook/webhook';




const Content = () => {
  return (
    <>
      <Routes>
        <Route path='dashboard' element={<Dashboard />} />
        <Route path='*' element={<NoFoundPage />} />

        <Route path='appointment/appointmentView/:appointmentId/:createdbyId' element={<AppointmentView />} />
        <Route path='appointment' element={<Appointment />} />

        <Route path='changePin' element={<ChangePin />} />

        <Route path='profile' element={<Profile />} />

        <Route path='state' element={<State />} />
        <Route path='state/addState' element={<AddState />} />
        <Route path='state/editState/:id' element={<EditState />} />

        <Route path='country' element={<Country />} />
        <Route path='country/addCountry' element={<AddCountry />} />
        <Route path='country/editCountry/:id' element={<EditCountry />} />

        <Route path='promotionalAddonPlan' element={<PromotionalAddOn />} />
        <Route path='promotionalAddonPlan/addMessage-plan' element={<AddPromotionalAddOn />} />
        <Route path='promotionalAddonPlan/editMessage-plan/:id' element={<EditPromotionalAddOn />} />

        <Route path='provider-list' element={<Provider />} />
        <Route path='provider-list/addProvider' element={<AddProvider />} />
        <Route path='provider-list/editProvider/:id' element={<EditProvider />} />
        <Route path='provider-list/assign-plan/:id' element={<AssignPlan />} />
        <Route path='provider-list/plan-details/:id' element={<PlanHistory />} />
        <Route path='provider-list/plan-details/:id/payment-history/:planId' element={<PaymentHistory />} />

        <Route path='revenue' element={<Revenue />} />
        {/* <Route path='campaign' element={<Campaign />} /> */}
        <Route path='campaign' element={<MainPage />}>
          <Route path='contact' element={<Contact />} /> 
          <Route path='webhook' element={<WebhookList />} /> 
          <Route path='contact/add-contact' element={<AddContact />} />
          <Route path='contact/edit-contact/:id' element={<AddContact />} />
          <Route path='group' element={<Group />} />
          <Route path='group/add-group' element={<AddGroup />} />
          <Route path='group/edit-group/:id' element={<AddGroup />} />
          <Route path='campaign' element={<Campaign />} />
          <Route path='campaign/add-campaign' element={<AddCampaign />} />
          <Route path='campaign/edit-campaign/:id' element={<AddCampaign />} />
          <Route path='campaign/email-campaign/:id' element={<EmailCampaign />} />
        </Route>

        <Route path='notification' element={<Notifications />} />
        <Route path='timeZone' element={<TimeZone />} />
        <Route path='role-list' element={<RoleList />} />
        <Route path='role-list/add-role' element={<AddRole />} />

        <Route path='duration' element={<ServiceDuration />} />
        <Route path='duration/add-duration' element={<AddDuration />} />

        <Route path='lead-management' element={<LeadManagement />} />
        <Route path='lead-management/view/:id' element={<View />} />
        <Route path='lead-management/add-lead' element={<AddLead />} />
        <Route path='lead-management/edit-lead/:id' element={<EditLead />} />
        <Route path='lead-management/lead-history/:id' element={<LeadHistory />} />
        <Route path='team-list' element={<TeamList />} />
        <Route path='team-list/add-team' element={<AddTeam />} />
        <Route path='cancellation-policy' element={<CancellationPolicy />} />
        <Route path='cancellation-policy/add-policy' element={<AddPolicy />} />
        <Route path='cancellation-policy/edit-policy/:id' element={<EditPolicy />} />
      </Routes>

    </>
  )
}

export default Content;